import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: `${theme.palette.background.default} !important`,
    marginTop: -22,
    marginLeft: -96,
    marginRight: -96,
    marginBottom: 56,
    [theme.breakpoints.down('sm')]: {
      marginRight: -14,
      marginLeft: -15
    }
  },
  header: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: 22,
      gap: 50,
      '& h3': {
        fontSize: 24
      }
    },
    '& h3': {
      color: theme.palette.grey[900]
    }
  },
  appBar: {
    backgroundColor: `${theme.palette.background.default} !important`
  },
  headerAndButtons: {
    display: 'flex',
    gap: 20,
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 32,
    [theme.breakpoints.down('md')]: {
      gap: 120
    },
    [theme.breakpoints.down('sm')]: {
      gap: 50
    }
  },

  transactionsListContainer: {
    marginBottom: 20
  },
  paymentMethodContainer: {
    marginBottom: 50
  },
  summeryOfPaymentContainer: {
    marginBottom: 20
  },
  proformaStatusContainer: {
    marginBottom: 50
  },
  detailsContainer: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: 20
  }
}))

export default useStyles
